"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const myCardItemContent_1 = __importDefault(require("./myCardItemContent"));
const myCardItemFooter_1 = __importDefault(require("./myCardItemFooter"));
const myCardItemHeader_1 = __importDefault(require("./myCardItemHeader"));
const MyCard = (0, material_1.styled)(material_1.Card)(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.palette.tsGoColor.white,
    border: '1px solid hsl(198, 20%, 83%)',
    borderRadius: '8px',
    padding: '18px 18px 9px 18px',
}));
const MyCardItem = ({ task }) => {
    const width = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 315 : 300;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, { sx: { minWidth: width, maxWidth: width }, "data-testid": "my-card-item", children: (0, jsx_runtime_1.jsxs)(MyCard, { children: [(0, jsx_runtime_1.jsx)(myCardItemHeader_1.default, { task: task }), (0, jsx_runtime_1.jsx)(myCardItemContent_1.default, { task: task }), (0, jsx_runtime_1.jsx)(myCardItemFooter_1.default, { task: task })] }) }) }));
};
exports.default = MyCardItem;
